module.exports = __webpack_public_path__ + "static/media/User_Group_People_Selected.cf0591e8.svg";